// @flow
import React, { useEffect, useState, useCallback, useMemo } from 'react'
import { useTheme } from '@mui/material/styles';
import * as DmsCommon from '../supports/dms-common';
import * as DmsService from '../supports/dms-service';
import { GlobalEvent, GlobalState } from './GlobalContext';
import DocInfoTab from './DocInfoTab';
import DocRevTab from './DocRevTab';
import DocSrcTab from './DocSrcTab';
import DocAttTab from './DocAttTab';
import DocCmtTab from './DocCmtTab';
import DocDListTab from './DocDListTab';
import DocShareTab from './DocShareTab';
import DocCheckHistTab from './DocCheckHistTab';
import DocPermissionTab from './DocPermissionTab';
import PropTypes from 'prop-types';
import Button from '@mui/material/Button';
import Dialog from '@mui/material/Dialog';
import DialogContent from '@mui/material/DialogContent';
import DialogActions from '@mui/material/DialogActions';
import Backdrop from '@mui/material/Backdrop';
import CircularProgress from '@mui/material/CircularProgress';

import Box from '@mui/material/Box';
import Tabs from '@mui/material/Tabs';
import Tab from '@mui/material/Tab';

function TabPanel(props) {
  const { children, value, index, ...other } = props;

  return (
    <div
      role="tabpanel"
      hidden={value !== index}
      id={`full-width-tabpanel-${index}`}
      aria-labelledby={`full-width-tab-${index}`}
      {...other}
    >
      {value === index && (
        <Box sx={{ p: 1 }}>
          {children}
        </Box>
      )}
    </div>
  );
}

TabPanel.propTypes = {
  children: PropTypes.node,
  index: PropTypes.number.isRequired,
  value: PropTypes.number.isRequired,
};

function a11yProps(index) {
  return {
    id: `full-width-tab-${index}`,
    'aria-controls': `full-width-tabpanel-${index}`,
  };
}

function DocDetailDialog(props) {
  const theme = useTheme();

  const { open, onClose, sysID, docDetail, afterDocDetailUpdate, docTypes,
    updatingDetail } = props;

  const [gState, gStateDispatch] = React.useContext(GlobalState);

  const folders = props.folders || [];

  const [hasUpdate, setHasUpdate] = useState(false);

  const handleCloseClick = () => {

    onClose && onClose(hasUpdate, gState.sessionID, sysID, docDetail.DocID);

    setHasUpdate(false);
  }



  const [value, setValue] = useState(0);

  const handleTabChange = (event, newValue) => {
    setValue(newValue);
  };

  const handleAfterDocDetailUpdate = () => {
    // console.log("DocDetailDialog handleAfterDocDetailUpdate", sysID, docDetail.DocID);
    setHasUpdate(true);

    docDetail && afterDocDetailUpdate && afterDocDetailUpdate(gState.sessionID, sysID, docDetail.DocID);
  }

  const docFolder = folders.find(f => f.id === docDetail?.FolderID)

  const [isFolderOffline, setIsFolderOffline] = useState(false);
  useEffect(() => {
    let isMounted = true;
    const checkOffline = async () => {
      if (docFolder?.IsMonitorFolder) {
        try {
          const res = await DmsService.getMonitorFolderStatusPromise(gState.sessionID, sysID, docFolder.id);
          if (isMounted) {
            setIsFolderOffline(res.isOffline);
          }
        } catch (err) {
          console.error(err);
        }
      } else {
        if (isMounted) {
          setIsFolderOffline(false);
        }
      }
    };
    checkOffline();
    return () => {
      isMounted = false;
    };
  }, [docFolder, sysID, gState.sessionID, open]);

  let vDisableEdit = true;

  if (docDetail) {
    if (docFolder) {
      // console.log("docFolder", docFolder);
      if (docFolder.Grade == -1) {
        vDisableEdit = (docDetail.Permission < DmsCommon.AccessRightEnum.arModify)
      } else {
        vDisableEdit = (docFolder.Grade < DmsCommon.AccessRightEnum.arModify)
      }

    }
  }

  const vAlwayEdit = ['DMS_DE', 'DMS_FM'].includes(sysID);

  return (
    <React.Fragment>


      <Dialog
        fullWidth={true}
        maxWidth="xl"
        open={open}
        scroll="paper"
        aria-describedby="dialog-doc-detail-doc"

        PaperProps={{
          sx: {
            display: 'flex',
            minHeight: "90vh",
            maxHeight: "90vh",
          }
        }}
      >
        <DialogContent dividers={scroll === 'paper'}>
          <Backdrop
            sx={{ color: '#fff', zIndex: (theme) => theme.zIndex.drawer + 1 }}
            open={updatingDetail}
          >
            <CircularProgress color="inherit" />
          </Backdrop>

          <Box sx={{
            width: '100%',
            // height: 100,
            bgcolor: 'background.paper',
            // display: 'flex',
            // height: '100vh',
            // flex: 1,
            // bgcolor: 'grey.300',
          }}>

            <Tabs
              value={value}
              onChange={handleTabChange}

              variant="scrollable"
              scrollButtons="auto"
            >
              <Tab label="Document Info." {...a11yProps(0)} />
              <Tab label="Revisions" {...a11yProps(1)} />
              <Tab label="Source Files" {...a11yProps(2)} />
              <Tab label="Attachment" {...a11yProps(3)} />
              <Tab label="Comments" {...a11yProps(4)} />
              <Tab label="Distribution List" {...a11yProps(5)} />
              <Tab label="Share" {...a11yProps(6)} />
              <Tab label="Check Out/In" {...a11yProps(7)} />
              <Tab label="Permissions" {...a11yProps(8)} />

            </Tabs>

            <TabPanel value={value} index={0} dir={theme.direction}>
              <DocInfoTab
                sysID={sysID}
                docDetail={docDetail}
                docTypes={docTypes}
                folders={folders}
                readonly={vDisableEdit}
                alwayEdit={vAlwayEdit}
                afterDocDetailUpdate={handleAfterDocDetailUpdate}
              />
            </TabPanel>
            <TabPanel value={value} index={1} dir={theme.direction}>
              <DocRevTab
                sysID={sysID}
                docDetail={docDetail}
                afterUpdate={handleAfterDocDetailUpdate}
                isFolderOffline={isFolderOffline}
              />
            </TabPanel>
            <TabPanel value={value} index={2} dir={theme.direction}>
              <DocSrcTab
                sysID={sysID}
                docDetail={docDetail}
                afterUpdate={handleAfterDocDetailUpdate}
                isFolderOffline={isFolderOffline}
              />
            </TabPanel>
            <TabPanel value={value} index={3} dir={theme.direction}>
              <DocAttTab
                sysID={sysID}
                docDetail={docDetail}
                afterUpdate={handleAfterDocDetailUpdate}
                isFolderOffline={isFolderOffline}
              />
            </TabPanel>
            <TabPanel value={value} index={4} dir={theme.direction}>
              <DocCmtTab
                sysID={sysID}
                docDetail={docDetail}
                afterUpdate={handleAfterDocDetailUpdate}
              />
            </TabPanel>
            <TabPanel value={value} index={5} dir={theme.direction}>
              <DocDListTab
                sysID={sysID}
                docDetail={docDetail}
                disableEdit={vDisableEdit}
                afterUpdate={handleAfterDocDetailUpdate}
              />
            </TabPanel>
            <TabPanel value={value} index={6} dir={theme.direction}>
              <DocShareTab
                sysID={sysID}
                docDetail={docDetail}
                afterUpdate={handleAfterDocDetailUpdate}
              />
            </TabPanel>
            <TabPanel value={value} index={7} dir={theme.direction}>
              <DocCheckHistTab
                sysID={sysID}
                docDetail={docDetail}
                docFolder={docFolder}
                afterUpdate={handleAfterDocDetailUpdate}
                isFolderOffline={isFolderOffline}
              />
            </TabPanel>
            <TabPanel value={value} index={8} dir={theme.direction}>
              <DocPermissionTab
                sysID={sysID}
                docDetail={docDetail}
                disableEdit={vDisableEdit}
                afterUpdate={handleAfterDocDetailUpdate}
              />
            </TabPanel>

          </Box>



        </DialogContent>
        <DialogActions>
          <Button onClick={handleCloseClick}>Close</Button>
        </DialogActions>
      </Dialog>

    </React.Fragment>


  );
}

DocDetailDialog.propTypes = {
  open: PropTypes.bool,
  onClose: PropTypes.func,
  sysID: PropTypes.string,
  docDetail: PropTypes.object,
  afterDocDetailUpdate: PropTypes.func,
  folders: PropTypes.array,
  docTypes: PropTypes.array,
  updatingDetail: PropTypes.bool,
};

export default DocDetailDialog